import toast from "react-hot-toast";
import { downloadPdfBlob } from "../../utils/pdf/tdcPdfTheme";

export const fetchAttachment = async (url: string): Promise<Response> => {
    const response = await fetch(url, { cache: "reload" });
    if (!response.ok) throw new Error(String(response.status));
    return response;
};

export const downloadAttachment = async (url: string, name: string) => {
    try {
        downloadPdfBlob(await (await fetchAttachment(url)).blob(), name);
    } catch {
        if (!window.open(url, "_blank", "noopener")) {
            toast.error("Couldn't download that file. Please try again.");
        }
    }
};
